'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThickCheckIcon = function ThickCheckIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M25.05 5.157C24.839 4.948 24.495 4.948 24.284 5.157L11.124 18.193 7.716 14.816C7.505 14.607 7.161 14.607 6.95 14.816L3.158 18.572C2.947 18.782 2.947 19.122 3.158 19.331L10.742 26.843C10.847 26.947 10.986 27 11.124 27 11.263 27 11.402 26.947 11.508 26.843L28.842 9.673C29.053 9.464 29.053 9.123 28.842 8.913L25.05 5.157Z'
    })
  );
};

ThickCheckIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = ThickCheckIcon;